import { optionalKey } from "@grandvisionhq/utils";
import { AddressLineFormat } from "../../../../../../models/models/checkout-settings.js";
const mapDataToFormValues = (data, addressLookup) => {
  const { city, postalCode, province, streetNumber } = data;
  let { streetName } = data;
  if (addressLookup?.shouldCombineAddress && streetNumber) {
    addressLookup.addressLineFormat = addressLookup.addressLineFormat ?? AddressLineFormat.streetName_streetNumber;
    const addressKeysSequence = addressLookup.addressLineFormat?.split("_");
    streetName = "";
    addressKeysSequence?.forEach((key) => {
      streetName += `${data[key]} `;
    });
  }
  return {
    streetName: streetName?.trim() ?? "",
    ...optionalKey("streetNumber", streetNumber),
    ...optionalKey("city", city),
    ...optionalKey("postalCode", postalCode),
    ...optionalKey("region", province)
  };
};
export {
  mapDataToFormValues
};
//# sourceMappingURL=map-data-to-form-values.js.map
